import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportAuditLogRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support-audit-log',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support/audit-log',
	exact: true,
};
